var map = {
	"./Auth/Login": 6134,
	"./Auth/Login.vue": 6134,
	"./Auth/Register": 6618,
	"./Auth/Register.vue": 6618,
	"./Categories/Create": 8508,
	"./Categories/Create.vue": 8508,
	"./Categories/Edit": 7815,
	"./Categories/Edit.vue": 7815,
	"./Categories/Index": 1520,
	"./Categories/Index.vue": 1520,
	"./Contacts/Create": 9916,
	"./Contacts/Create.vue": 9916,
	"./Contacts/Edit": 5557,
	"./Contacts/Edit.vue": 5557,
	"./Contacts/Index": 5781,
	"./Contacts/Index.vue": 5781,
	"./Dashboard/Index": 1689,
	"./Dashboard/Index.vue": 1689,
	"./Organizations/Create": 1357,
	"./Organizations/Create.vue": 1357,
	"./Organizations/Edit": 8536,
	"./Organizations/Edit.vue": 8536,
	"./Organizations/Images": 4009,
	"./Organizations/Images.vue": 4009,
	"./Organizations/Index": 1083,
	"./Organizations/Index.vue": 1083,
	"./Products/Create": 7133,
	"./Products/Create.vue": 7133,
	"./Products/Edit": 429,
	"./Products/Edit.vue": 429,
	"./Products/Index": 1423,
	"./Products/Index.vue": 1423,
	"./Reports/Index": 5392,
	"./Reports/Index.vue": 5392,
	"./Transaccions/Create": 320,
	"./Transaccions/Create.vue": 320,
	"./Transaccions/Edit": 660,
	"./Transaccions/Edit.vue": 660,
	"./Transaccions/Index": 664,
	"./Transaccions/Index.vue": 664,
	"./Users/Create": 8395,
	"./Users/Create.vue": 8395,
	"./Users/Edit": 9079,
	"./Users/Edit.vue": 9079,
	"./Users/Index": 2773,
	"./Users/Index.vue": 2773
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8846;